import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getBaseUrl } from "../../Utils/Utils";

const checkAvailability = createAsyncThunk("check/pincode", async(pincode)=>{
    const url = getBaseUrl();
    const response = await axios.post(`${url}/Products/checkPincode?Pincode=${pincode}`);
    return response.data
})
export {checkAvailability}